import { getIn } from 'seamless-immutable';
import { stringify } from 'query-string';
import { sendBeacon } from '@catalogo/core-send-beacon';
import { getPageType } from '@catalogo/core-connect/page-type';
import { readConfig } from '@catalogo/core-connect/config';
import { readCookies } from '@catalogo/core-connect/cookies';
import { getDevice } from '@catalogo/core-connect/device';

export const PAGETYPES = {
  search: 'Busca',
  home: 'Home',
  product: 'Produto',
  services: 'GarantiaProduto',
};

const getPal = (impressions, body) => {
  const { props } = body;
  const item = impressions.find(elem => elem.id === getIn(props, ['id']));
  const pal = getIn(item, ['list'], getIn(props, ['position']));

  return pal;
};

export const outOfStockLoad = ({ routerProps, client, body }) => {
  const pageType = getPageType(routerProps?.location?.pathname);
  const device = getDevice(client);
  const { config } = readConfig(client);
  const { cookies } = readCookies(client);

  const ga = getIn(cookies, ['_ga'], '').slice(6);
  const dataLayer = getIn(window, ['dataLayer'], []);
  const pageview = dataLayer.find(elem => elem?.event?.includes('pageview'));
  const impressions = getIn(pageview, ['ecommerce', 'impressions'], []);
  const pal = getPal(impressions, body);

  const bestPaymentOption = getIn(body.product.offers, ['result', 0, 'bestPaymentOption']);
  const salesPrice = getIn(bestPaymentOption, ['minInstallment', 0, 'total']) || getIn(bestPaymentOption, ['price']);

  const params = {
    t: 'event',
    tid: config.ga,
    pr1pr: salesPrice,
    pr1cd80: getIn(body.product.offers, ['result', 0, 'offerId'], ''),
    pr1cd89: getIn(body.product.offers, ['result', 0, 'stamps', 'oneDayDelivery'], []).join(),
    pr1cd65: getIn(body.product.offers, ['result', 0, 'stamps', 'prime']),
    ec: 'produtos-recomendacao',
    ea: 'sem-estoque',
    pa: 'load',
    cid: ga,
    uid: cookies['B2W-UID'],
    cd1: cookies['B2W-UID'],
    cd15: PAGETYPES[pageType],
    cd25: device !== 'desktop',
    cd44: 'Responsivo',
    cd60: cookies['B2W-PID'],
    cd61: cookies['B2W-SID'],
    cd104: getIn(pageview, ['pagename'], `${config.brand.toUpperCase()}:${pageType}`),
    dt: document.title,
    dl: window.location.href,
    dp: `${window.location.pathname}${window.location.search}`,
    pal,
    pr1id: getIn(body.props, ['id']),
    pr1ps: getIn(body.props, ['index']) + 1,
  };

  try {
    sendBeacon(`https://www.google-analytics.com/j/collect?v=1&${stringify(params)}`);
  } catch (e) {
    console.info(e);
  }
};
